<template>
    <!-- Loader -->
    <div
        v-if="loading"
        class="d-flex justify-content-center align-items-center"
    >
        <span class="spinner spinner-big pointer-events-none"/>
    </div>

    <!-- Main block -->
    <div
        v-else
        class="verbs-list accordion"
    >
        <div class="search-input-wrapper mb-3">
            <!-- Search input -->
            <input
                v-model="query"
                class="search-input"
                :class="{'not-empty': query.length}"
                maxlength="70"
                placeholder="Введите форму III л. ед. числа или имени действия (пока только на грузинском)"
                @input="search"
            >
            <!-- Clear the search query -->
            <button
                v-if="query.length"
                class="btn btn-close search-clear"
                @click="searchClear"
            />
        </div>

        <!-- Verbs -->
        <template v-if="verbsFound.slice(0, limit).length">
            <div
                v-for="verb in verbsFound.slice(0, limit)"
                :key="verb.id"
                class="word"
            >
                <div class="accordion-item">
                    <!-- Accordion button -->
                    <button
                        :id="`verb-heading-${verb.id}`"
                        :aria-controls="`verb-collapse-${verb.id}`"
                        :data-bs-target="`#verb-collapse-${verb.id}`"
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        aria-expanded="false"
                    >
                        <span
                            class="word-name"
                            v-html="verb.highlightedName || verb.name"
                        />
                    </button>

                    <!-- Accordion itself -->
                    <div
                        :id="`verb-collapse-${verb.id}`"
                        :aria-labelledby="`verb-heading-${verb.id}`"
                        class="accordion-collapse collapse"
                    >
                        <div class="accordion-body">
                            <p class="mb-0">
                                <b>Имя действия</b>:
                                <span v-html="verb.highlightedInfinitive || verb.infinitive || '–'"/>
                            </p>

                            <p class="series mt-2 pt-1">
                                I серия
                            </p>
                            <div class="row">
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Настоящее
                                    </p>
                                    <p v-html="breakWords(verb.present) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Прошедшее незаконченное
                                    </p>
                                    <p v-html="breakWords(verb.imperfect) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Сослагательное I
                                    </p>
                                    <p v-html="breakWords(verb.presentSubjunctive) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Будущее
                                    </p>
                                    <p v-html="breakWords(verb.future) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Условное
                                    </p>
                                    <p v-html="breakWords(verb.conditional) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Сослагательное будущего
                                    </p>
                                    <p v-html="breakWords(verb.futureSubjunctive) || '–'"/>
                                </div>
                            </div>

                            <p class="series">
                                II серия
                            </p>
                            <div class="row">
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Прошедшее законченное
                                    </p>
                                    <p v-html="breakWords(verb.aorist) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Сослагательное II
                                    </p>
                                    <p v-html="breakWords(verb.optative) || '–'"/>
                                </div>
                            </div>

                            <p class="series">
                                III серия
                            </p>
                            <div class="row">
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Прошедшее результативное I
                                    </p>
                                    <p v-html="breakWords(verb.perfect) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Прошедшее результативное II
                                    </p>
                                    <p v-html="breakWords(verb.pluperfect) || '–'"/>
                                </div>
                                <div class="col-lg-4">
                                    <p class="fw-bold">
                                        Сослагательное III
                                    </p>
                                    <p v-html="breakWords(verb.perfectSubjunctive) || '–'"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- Not found -->
        <div v-else>
            <p class="mt-3">
                Не найдено.
            </p>
        </div>

        <!-- Show more -->
        <div
            v-if="verbsFound.length > limit"
            class="text-center"
        >
            <a
                class="extend"
                href=""
                @click.prevent="extendLimit(15)"
            >
                Показать ещё
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Verbs',
    data() {
        return {
            verbs: [],
            verbsFound: [],
            query: '',
            limit: 7,
            loading: true,
        }
    },
    created() {
        this.fetchVerbs()
    },
    mounted() {
        $('.search-input').focus()
    },
    methods: {
        // Get verb data
        fetchVerbs() {
            axios.get('/api/dictionary/get-verbs')
                .then(response => {
                    this.verbs = this.verbsFound = response.data.verbs
                    this.loading = false
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // Extend the verb limit
        extendLimit(extension) {
            this.limit += extension
        },

        // Insert line breaks if there are several words
        breakWords(text) {
            if (text) {
                return text.replaceAll(',', '<br>')
            }
        },

        // Search verbs
        search() {
            // Collapse all accordions
            $('.collapse').removeClass('show')
            $('.accordion-button').addClass('collapsed')

            // Reset the verb limit
            this.limit = 7

            // Filter verbs according to the input query
            this.verbsFound = this.verbs.filter((word) => {
                return word.name?.includes(this.query) || word.infinitive?.includes(this.query)
            })

            // Results highlighting
            this.verbsFound.map((word) => {
                word.highlightedName = word.name?.replace(this.query, `<span class="hl">${this.query}</span>`)
                word.highlightedInfinitive = word.infinitive?.replace(this.query, `<span class="hl">${this.query}</span>`)
            })
        },

        // Clear the search query
        searchClear() {
            this.query = ''
            this.search()
        }
    }
}
</script>

<style lang="scss" scoped>
.search-input-wrapper {
    position: relative;
    .search-input {
        width: 100%;
        padding: 15px;
        border: 1px solid #ddd;
        color: #222;
        font-size: 18px;
        &.not-empty {
            padding: 15px 64px 15px 15px;
        }
    }
    .search-clear {
        position: absolute;
        top: 50%;
        right: 0;
        height: 100%;
        padding: 0 1.5rem;
        border: none;
        box-shadow: none;
        transform: translateY(-50%);
    }
}
.word {
    border: 1px solid #ddd;
    // padding: 10px;
    margin: 16px 0;
    :deep(.hl) {
        background: #ffdd4b63;
    }
}
.accordion {
    .accordion-item {
        border: none;
        .accordion-body {
            padding: 0 1.5rem 1.1rem;
            .row .col-lg-4 {
                p {
                    margin-bottom: 11px;
                    &:first-of-type {
                        margin-bottom: 0;
                    }
                }
            }
            .series {
                display: inline-block;
                margin-top: 3px;
                margin-bottom: .25rem;
                color: #4c8aff;
                font-size: 20px;
            }
        }
        .accordion-button {
            padding: 1.5rem;
            background: none !important;
            box-shadow: none !important;
            color: inherit !important;
            &::after {
                background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")
            }
            .word-name {
                font-weight: bold;
            }
        }
    }
}
.extend {
    display: inline-block;
    padding: 7px 20px;
    margin-top: 12px;
    background: #dd0000;
    color: #fff;
    // color: #0a53be;
    font-size: 1rem;
    font-weight: 600;
    transition: .2s ease;
}

@media (width < 992px) {
    .search-input-wrapper {
        .search-input.not-empty {
            padding: 15px 54px 15px 15px;
        }
        .search-clear {
            padding: 0 1.2rem;
        }
    }
}
</style>
